import React from 'react';
import t from 'prop-types';

var Miniatura = function Miniatura(_ref) {
  var fc = _ref.fc,
      seleccionada = _ref.seleccionada,
      ruta = _ref.ruta,
      _ref$onSeleccionar = _ref.onSeleccionar,
      onSeleccionar = _ref$onSeleccionar === undefined ? function () {
    return false;
  } : _ref$onSeleccionar;

  if (fc.length === 0) {
    return false;
  }

  var rutaFCs = ruta || 'contenido/FCs/flashcards';
  var tipo = fc.substring(0, 1);
  var nombre = fc.substring(1, 4); //const src = rutaFCs + `/img${tipo}/${nombre}.png`

  var src = rutaFCs + ('/min' + tipo + '/' + nombre + '.png');
  return React.createElement('div', {
    className: 'miniatura' + (seleccionada ? ' activa' : '')
  }, React.createElement('img', {
    className: 'imagenMiniatura',
    src: src,
    onClick: onSeleccionar,
    alt: nombre
  }), React.createElement('div', {
    className: 'textoMiniatura'
  }));
};

Miniatura.propTypes = process.env.NODE_ENV !== "production" ? {
  fc: t.string,
  seleccionada: t.bool,
  onSeleccionar: t.func,
  ruta: t.string
} : {};

var CajaMiniaturas = function CajaMiniaturas(_ref2) {
  var flashcards = _ref2.flashcards,
      seleccionadas = _ref2.seleccionadas,
      _onSeleccionar = _ref2.onSeleccionar,
      ruta = _ref2.ruta;
  return React.createElement('div', {
    className: 'cajaMiniaturas multilinea'
  }, React.createElement('div', {
    className: 'deslizadorMiniaturas'
  }, flashcards.map(function (fc, index) {
    return React.createElement(Miniatura, {
      key: fc,
      fc: fc,
      ruta: ruta,
      onSeleccionar: function onSeleccionar() {
        return _onSeleccionar(index);
      },
      seleccionada: seleccionadas[index]
    });
  })));
};

CajaMiniaturas.propTypes = process.env.NODE_ENV !== "production" ? {
  flashcards: t.array,
  seleccionadas: t.array,
  onSeleccionar: t.func,
  ruta: t.string
} : {};
export default CajaMiniaturas;